import type { DataChartStyleProps } from './datachartStyleRegistry'
import { EnergyChartThreePhaseBase } from './EnergyChartThreePhaseBase'

export function EnergyChartStyle03(props: DataChartStyleProps) {
  return <EnergyChartThreePhaseBase variant="blue" chartType="area" {...props} />
}
